module.exports = __webpack_public_path__ + "static/media/20.73f7a9ea.mp3";